// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__82gJB","content":"styles_content__wCPmn","tableWrap":"styles_tableWrap__TiSKe"};